import { cn } from '../../utils/cn';
import type { DotsLoaderProps } from './dots-loader.types';
import styles from './dots-loader.module.css';

/**
 * DotsLoader component - Animated loading dots indicator
 */
export const DotsLoader = ({ size = 'medium', color = 'primary', className }: DotsLoaderProps) => {
    return (
        <div className={cn(styles.root, className)}>
            {[0, 1, 2].map(index => (
                <span
                    key={index}
                    className={cn(styles.dot, styles[size], styles[color])}
                    style={{
                        animationDelay: `${index * 0.15}s`,
                    }}
                />
            ))}
        </div>
    );
};
